import { Navigation } from './Navigation'
import { ReactWrapper } from '@components'

export const NavigationComponent = ReactWrapper(Navigation, 'navigation')
